import { useEffect } from 'react';

const useJivoChat = (isChatVisible: boolean) => {
    useEffect(() => {
        // Constants for JivoChat settings
        const jivoId = 'aOt82J9SDn';
        const jivoChatScriptSrc = 'https://code.jivosite.com/widget.js';

        // Function to toggle visibility of JivoChat elements
        const toggleJivoElementsVisibility = () => {
            const jdiv: HTMLElement | null = document.getElementById("globalClass_ebf4");

            // Toggle visibility of elements with class globalClass_ebf4
            document.querySelectorAll('.globalClass_ebf4').forEach(element => {
                element.classList.toggle('jvlabelNone', !isChatVisible);
                element.classList.toggle('jvlabelBlock', isChatVisible);
            });

            // Toggle visibility of jdiv if exists
            if (jdiv) {
                jdiv.classList.toggle('jvlabelNone', !isChatVisible);
                jdiv.classList.toggle('jvlabelBlock', isChatVisible);

                // Add or remove globalClass_ebf4 based on isChatVisible
                if (isChatVisible) {
                    jdiv.classList.add('globalClass_ebf4');
                } else {
                    jdiv.classList.remove('globalClass_ebf4');
                }
            }
        };

        // Function to remove JivoChat elements
        const removeJivoElements = () => {
            document.querySelectorAll('[data-jv-id]').forEach(element => {
                element.parentNode?.removeChild(element);
            });
        };

        // Function to remove JivoChat script
        const removeJivoScript = () => {
            const jivoChatScript: HTMLScriptElement | null = document.querySelector(`[data-jv-id="${jivoId}"]`);
            if (jivoChatScript && jivoChatScript.parentNode) {
                jivoChatScript.parentNode.removeChild(jivoChatScript);
            }
        };

        // Function to handle JivoChat script load
        const handleJivoScriptLoad = () => {
            if (!isChatVisible) {
                removeJivoElements();
                removeJivoScript();
            }
        };

        // Effect for adding or removing JivoChat script
        if (isChatVisible) {
            removeJivoElements();

            const jivoChatScript = document.createElement('script');
            jivoChatScript.src = jivoChatScriptSrc;
            jivoChatScript.setAttribute('data-jv-id', jivoId);
            jivoChatScript.onload = handleJivoScriptLoad;
            document.body.appendChild(jivoChatScript);
        } else {
            removeJivoElements();
            removeJivoScript();
        }

        // Toggle visibility of JivoChat elements
        toggleJivoElementsVisibility();

        // Cleanup function
        return () => {
            removeJivoElements();
            removeJivoScript();
        };
    }, [isChatVisible]);
};

export default useJivoChat;
